import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { SignatureClientContext } from "../components/Notifications/templates/SignatureClient";

export const selectorSignatureClientNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return response.handle === NotificationHandleType.SignatureClient;
  }) as Array<WSNotificationResponse<SignatureClientContext>>;
};
